export default function initializePostList() {
    document.querySelectorAll('.block-post-list[data-ajax="1"]').forEach(function (block) {
        new PostList(block);
    });
}

class PostList {
    constructor(block) {
        this.block = block;
        this.list = block.querySelector('.block-post-list__list');
        this.tabs = block.querySelectorAll('.block-post-list__tab');
        this.loader = block.querySelector('.block-post-list__loader');

        this.config = {
            categories: block.dataset.categories || '',
            perPage: parseInt(block.dataset.perPage) || 12,
            columns: parseInt(block.dataset.columns) || 3,
            showThumbnail: parseInt(block.dataset.showThumbnail) || 0,
            showDate: parseInt(block.dataset.showDate) || 0,
            showExcerpt: parseInt(block.dataset.showExcerpt) || 0,
            showCategoryBadge: parseInt(block.dataset.showCategoryBadge) || 0,
        };

        this.apiBase = (window.wpApiSettings?.root || '/wp-json/') + 'venti/v1/posts/';
        this.init();
    }

    init() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                this.tabs.forEach(t => t.classList.remove('block-post-list__tab--active'));
                tab.classList.add('block-post-list__tab--active');

                const category = tab.dataset.category || '';
                this.loadPosts(category);
            });
        });
    }

    buildUrl(category) {
        const params = new URLSearchParams({
            per_page: this.config.perPage,
            columns: this.config.columns,
            show_thumbnail: this.config.showThumbnail,
            show_date: this.config.showDate,
            show_excerpt: this.config.showExcerpt,
            show_category_badge: this.config.showCategoryBadge,
        });

        if (this.config.categories) {
            params.set('categories', this.config.categories);
        }

        if (category) {
            params.set('category', category);
        }

        return this.apiBase + '?' + params.toString();
    }

    loadPosts(category) {
        this.showLoader();

        fetch(this.buildUrl(category))
            .then(response => response.json())
            .then(data => {
                this.renderPosts(data.results || []);
                this.hideLoader();
            })
            .catch(() => {
                this.hideLoader();
            });
    }

    renderPosts(posts) {
        if (!posts.length) {
            this.list.innerHTML = '<div class="col-12"><p>Brak wpisów do wyświetlenia.</p></div>';
            return;
        }

        this.list.innerHTML = posts.map(post => this.renderCard(post)).join('');
    }

    renderCard(post) {
        let thumbnailHtml = '';
        if (this.config.showThumbnail) {
            const imgSrc = post.thumbnail
                ? `<img src="${post.thumbnail.src}" srcset="${post.thumbnail.srcset || ''}" sizes="${post.thumbnail.sizes || ''}" alt="${this.escHtml(post.title)}" loading="lazy"/>`
                : `<img src="${post.noimage}" alt="${this.escHtml(post.title)}" loading="lazy"/>`;

            let badgeHtml = '';
            if (this.config.showCategoryBadge && post.categories.length) {
                const cats = post.categories.map(c => {
                    return `<span class="block-post-list__badge-sep">|</span><span class="block-post-list__badge-name">${this.escHtml(c)}</span>`;
                }).join('');
                badgeHtml = `<div class="block-post-list__badge">${cats}</div>`;
            }

            thumbnailHtml = `
                <a href="${post.link}" class="block-post-list__thumbnail">
                    ${imgSrc}
                    ${badgeHtml}
                </a>`;
        }

        let metaHtml = '';
        if (this.config.showDate && post.meta) {
            let authorHtml = '';
            if (post.meta.author) {
                authorHtml = `
                    <span class="block-post-list__meta-sep">/</span>
                    <a href="${post.meta.author_url}" class="block-post-list__author">${this.escHtml(post.meta.author)}</a>`;
            }
            metaHtml = `
                <div class="block-post-list__meta">
                    <span class="block-post-list__date">${post.meta.date}</span>
                    ${authorHtml}
                </div>`;
        }

        let excerptHtml = '';
        if (this.config.showExcerpt && post.excerpt) {
            excerptHtml = `<p class="block-post-list__excerpt">${this.escHtml(post.excerpt)}</p>`;
        }

        return `
            <div class="${post.column_class} mb-4">
                <article class="block-post-list__card">
                    ${thumbnailHtml}
                    <div class="block-post-list__content">
                        ${metaHtml}
                        <a href="${post.link}" class="block-post-list__title-link">
                            <h3 class="block-post-list__title">${this.escHtml(post.title)}</h3>
                        </a>
                        ${excerptHtml}
                        <a href="${post.link}" class="block-post-list__button">
                            ${this.escHtml(post.read_more)}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.33 8h9.34M8.67 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                </article>
            </div>`;
    }

    showLoader() {
        this.list.style.opacity = '0.4';
        this.list.style.pointerEvents = 'none';
        if (this.loader) this.loader.style.display = 'flex';
    }

    hideLoader() {
        this.list.style.opacity = '1';
        this.list.style.pointerEvents = '';
        if (this.loader) this.loader.style.display = 'none';
    }

    escHtml(str) {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }
}
